/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMfrmDeliveryShippingViewProps } from './mfrm-delivery-shipping';

export default (props: IMfrmDeliveryShippingViewProps) => {
    const isRedesign = props.config.enableDeliveryShippingInfoRedesign;

    return  isRedesign ? (
        <div className='mfrm-delivery-shipping-redesign__container '>
            {props.tableListContent}
            {props.deliveryShippingContent}
        </div>
    )
        : (<div className='mfrm-delivery-shipping__container '>
            {props.tableListContent}
            {props.deliveryShippingContent}
            {props.learnMoreLink && (
                <div className='learnMore'>
                    <a
                        title={props.learnMoreLink.linkText}
                        href={props.learnMoreLink.linkUrl && props.learnMoreLink.linkUrl.destinationUrl}
                        aria-label={props.learnMoreLink.ariaLabel}
                        target={props.learnMoreLink.openInNewTab ? '_blank' : undefined}
                    >
                        {props.learnMoreLink.linkText}
                    </a>
                </div>
            )}
        </div>);
};
